/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentIdentifier { 
    incident_id: string;
    mandant_id: string;
    veranstaltung_id?: string;
    verantwortlichkeit_funktionsbereich_id?: string;
    modified_on_utc: Date;
}

